module.exports = __webpack_public_path__ + "static/media/grafico-unicred-centro-sul-3.42e6c8fe.png";